import { ColorAddiFontStrong, ColorAddiFontHint, ColorAddiGrayLighten3, ColorAddiFontSecondary, ColorAddiFontError, ColorAddiFontPrimary, ColorAddiCompFiveBase, ColorAddiCompTwoDarken2, ColorAddiCompTwoDarken1, } from '@addi/foundation/dist/web/colors';
import { FontAddiFamilySecondaryName, FontAddiWeightBold, FontAddiWeightMedium, FontAddiWeightSemiBold, } from '@addi/foundation/dist/web/fonts';
import { SizeAddiFontSmall } from '@addi/foundation/dist/web/sizes';
import styled, { css } from 'styled-components';
import ReactInputMask from 'react-input-mask';
import { Label } from '../typographies';
// fix for TS2742 error
const ReactCurrencyInputField = require('react-currency-input-field').default;
export var TEXT_ALIGN;
(function (TEXT_ALIGN) {
    TEXT_ALIGN["LEFT"] = "left";
    TEXT_ALIGN["RIGHT"] = "right";
    TEXT_ALIGN["CENTER"] = "center";
})(TEXT_ALIGN || (TEXT_ALIGN = {}));
export const LabelTxt = styled.span `
  position: relative;
`;
export const Prefix = styled.span `
  color: ${ColorAddiFontPrimary};
  display: inline-block;
  position: absolute;
  z-index: 2;
  top: 5px;
  left: 0;
  width: 1.2rem;
`;
export const TxtPrefix = styled(Prefix) `
  font-size: ${SizeAddiFontSmall};
  line-height: 1.8rem;
  text-align: center;
  font-family: ${FontAddiFamilySecondaryName};
  font-weight: ${FontAddiWeightBold};
  color: ${ColorAddiFontSecondary};
  top: 0.43rem;
  margin: 0;
  height: 1.4rem;
`;
export const IconPrefix = styled(Prefix) `
  height: 1.3rem;
  margin: 0.3rem 0.1rem;
  text-align: center;
  font-weight: ${FontAddiWeightBold};
  & > svg {
    height: 1.2rem;
    color: ${ColorAddiFontSecondary};
  }
`;
export const IconSubfix = styled(Prefix) `
  height: 1.3rem;
  margin: 0.3rem 0.1rem;
  text-align: center;
  font-weight: ${FontAddiWeightBold};
  right: 0;
  left: initial;
  & > svg {
    height: 1.2rem;
    color: ${ColorAddiFontSecondary};
  }
`;
export const InputLabel = styled(Label) `
  position: absolute;
  left: 0;
  top: -10px;
  padding: 0;
  pointer-events: none;
  letter-spacing: 0.02rem;
  line-height: 17px;

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    top: 10px;
    left: 0;
    z-index: 0;
  }
`;
export const input = css `
  width: 100%;
  height: 100%;
  padding: 1.2rem 0 0.7rem;
  border: none;
  border-bottom: solid 1px ${ColorAddiGrayLighten3};
  background: transparent;
  box-sizing: border-box;
  color: ${ColorAddiFontPrimary};
  letter-spacing: 0.02rem;
  font-size: ${SizeAddiFontSmall};
  line-height: 21px;
  font-family: ${FontAddiFamilySecondaryName};
  font-weight: ${FontAddiWeightSemiBold};

  &:disabled {
    color: ${ColorAddiFontSecondary};

    & + ${Label} {
      color: ${ColorAddiFontStrong};
    }
  }

  &:focus {
    outline: none;
    border-width: 1px;
    border-color: ${ColorAddiCompFiveBase};

    &::before {
      border-width: 1px;
    }
  }

  &::placeholder {
    color: ${ColorAddiFontHint};
  }

  /* Chrome, Safari, Edge, Opera */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type='number'] {
    -moz-appearance: textfield;
  }
`;
export const Input = styled.input `
  ${input}
  padding-left: ${(props) => (props.$withPrefix && 2.2) || (props.$withIconPrefix && 1.5) || 0}rem;
  text-align: ${(props) => (props.$textAlign ? props.$textAlign : 'left')};
`;
export const InputWithMask = styled(ReactInputMask) `
  ${input}
  padding-left: ${(props) => (props.$withPrefix ? 1.4 : 0)}rem;
  text-align: ${(props) => (props.$textAlign ? props.$textAlign : 'left')};
`;
export const CurrencyInputField = styled(ReactCurrencyInputField) `
  ${input};
  padding-left: ${(props) => (props.withPrefix && 2.2) || (props.withIconPrefix && 1.5) || 0}rem;
`;
export const TextArea = styled.textarea `
  ${input}
  text-align: ${(props) => (props.textAlign ? props.textAlign : 'left')};
  min-height: 220px;
`;
export const InputContainer = styled.div `
  width: 100%;
  height: 2.2rem;
  position: relative;

  ${(props) => !props.error && props.warn ?
    css `
      ${Input} {
        border-bottom-color: ${ColorAddiCompTwoDarken1};
      }

      ${InputWithMask} {
        border-bottom-color: ${ColorAddiCompTwoDarken1};
      }
    `
    : props.error &&
        css `
      ${Input} {
        border-bottom-color: ${ColorAddiFontError};
      }

      ${InputWithMask} {
        border-bottom-color: ${ColorAddiFontError};
      }
    `}
`;
export const Container = styled.div `
  display: inline-block;
  width: ${(props) => (props.width ? props.width : '220px')};
  font-family: ${FontAddiFamilySecondaryName};
  font-size: ${SizeAddiFontSmall};
  line-height: 21px;
  font-weight: ${FontAddiWeightMedium};
  padding-top: 6px;
`;
export const Helpers = styled.div `
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-top: 5px;
`;
export const Hint = styled(Label) `
  line-height: 14px;
  margin: 0;
  color: ${ColorAddiFontHint};
  width: 100%;
  padding: 0;
`;
export const Warn = styled(Label) `
  line-height: 14px;
  margin: 0;
  color: ${ColorAddiCompTwoDarken2};
  width: 100%;
  padding: 0;
`;
export const Error = styled(Hint) `
  color: ${ColorAddiFontError};
`;
export const StoryDiv = styled.div `
  margin: 30px;
`;
//# sourceMappingURL=TextInput.styled.js.map